import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TruthSection } from './components/TruthSection';
import { MechanismSection } from './components/MechanismSection';
import { TransformationSection } from './components/TransformationSection';
import { WhatIncluded } from './components/WhatIncluded';
import { WhoIsItFor } from './components/WhoIsItFor';
import { PricingCTA } from './components/PricingCTA';
import { ClosingSection } from './components/ClosingSection';
import { FloatingCTA } from './components/FloatingCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    ;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      const parent = s ? s.parentNode : b.head || b.body;
      parent.insertBefore(t, s || null);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    const fbq = (window as any).fbq;
    fbq('init', '1222089303436057');
    fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full bg-[#FDF8F0]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <TruthSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <TransformationSection data-id="element-5" />
      <WhoIsItFor data-id="element-6" />
      <PricingCTA data-id="element-7" />
      <ClosingSection data-id="element-8" />
      <Footer data-id="element-9" />
      <FloatingCTA data-id="element-10" />
    </main>;
}